import Insight from "../insightClass";
import React from "react";
import { insight106Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight106 = new Insight(
  "06 April 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight106Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-04-06)",
  "",
  `TenneT and National Grid Ventures have signed a Joint Development Agreement to advance the LionLink hybrid interconnector, linking the UK and the Netherlands via the future Nederwiek 3 offshore wind farm. The project, planned at up to 2 GW capacity, aims to integrate offshore wind generation with cross-border electricity trading. `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-04-06)</h1>
    <h2></h2>
    <p className="article-date">06 April 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>
      1. TenneT and National Grid advance LionLink UK–Netherlands interconnector
    </h3>
    <p>
      TenneT and National Grid Ventures have signed a Joint Development
      Agreement to advance the LionLink hybrid interconnector, linking the UK
      and the Netherlands via the future Nederwiek 3 offshore wind farm. The
      project, planned at up to 2 GW capacity, aims to integrate offshore wind
      generation with cross-border electricity trading. 
    </p>
    <p>
      The agreement sets out governance, procurement and development
      responsibilities as the project moves towards final investment decision.
      LionLink is expected to apply for UK planning consent in 2026, with
      commissioning targeted in the early 2030s.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      LionLink reflects a structural shift in how offshore wind is integrated
      into power systems. Traditional radial connections are increasingly
      inefficient in a high-renewables system, where flexibility and
      cross-border balancing become critical. Hybrid interconnectors allow
      countries to share both generation and system balancing resources,
      reducing curtailment and improving asset utilisation. Strategically,
      LionLink is part of a broader North Sea transition towards a meshed
      offshore grid. 
    </p>
    <p>
      This has implications beyond transmission: it reshapes project economics,
      regulatory frameworks and ownership models. Developers will need to adapt
      to a system where grid architecture is no longer project-specific but
      increasingly network-driven, with TSOs playing a more central coordinating
      role.
    </p>
    <h3>2. France reaches halfway point on Dieppe-Le Tréport foundations</h3>
    <p>
      The 496 MW Dieppe-Le Tréport offshore wind project has reached a key
      construction milestone, with 31 of its 62 jacket foundations now
      installed. Located off the northern French coast, the project is being
      developed by Ocean Winds in partnership with Sumitomo Corporation and
      Banque des Territoires. Foundation installation began in 2025, and turbine
      installation is scheduled for 2026, with Siemens Gamesa supplying 8 MW
      units manufactured in Le Havre. Substructures are being fabricated in
      Spain, highlighting the cross-European nature of the supply chain.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Execution progress is becoming one of the most important credibility
      indicators in the European offshore wind market. France has historically
      faced delays due to permitting complexity and policy uncertainty, so
      visible construction milestones carry disproportionate weight. This
      project demonstrates that once projects move into execution, industrial
      coordination across Europe can function effectively. 
    </p>
    <p>
      It also reinforces the continued role of jacket foundations in
      deeper-water fixed-bottom projects. More broadly, steady construction
      progress helps de-risk investor perception of the French market, which
      remains strategically important but has lagged leading markets such as the
      UK and Germany in delivery pace.
    </p>
    <h3>
      3. France launches 12 GW renewable tenders with offshore wind at the core
    </h3>
    <p>
      France has launched a new 12 GW renewable energy tender programme,
      including 10 GW of offshore wind capacity across multiple projects. The
      initiative supports the country’s target of reaching 15 GW of installed
      offshore wind by 2035. 
    </p>
    <p>
      The tender framework introduces new “resilience” criteria designed to
      strengthen European supply chains, including limits on the use of certain
      non-European components such as permanent magnets. Additional
      sustainability and cybersecurity requirements are also expected to be
      incorporated into future rounds.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This marks a clear evolution in European offshore wind policy. France is
      moving beyond cost-driven auctions and embedding industrial strategy
      directly into procurement mechanisms. The introduction of resilience
      criteria effectively reshapes competition by influencing supply chain
      choices without explicitly excluding international players. This aligns
      with broader EU efforts to strengthen domestic manufacturing and reduce
      dependency on external suppliers. 
    </p>
    <p>
      For developers, this means bid strategies will increasingly need to
      balance cost competitiveness with supply chain positioning. Over time,
      such frameworks could lead to a more regionally anchored offshore wind
      industry, but potentially at the cost of higher short-term project
      economics.
    </p>
    <h3>4. CRP Subsea secures Nordlicht I cable protection contract</h3>
    <p>
      CRP Subsea has secured a contract with Jan De Nul to supply 141 cable
      protection systems for Vattenfall’s 980 MW Nordlicht I offshore wind
      project in the German North Sea. The systems will protect inter-array
      cables at key connection points, including turbine and platform
      interfaces, and are designed to prevent over-bending, abrasion and
      fatigue. Engineering is already underway, with manufacturing to take place
      in northwest England and delivery scheduled for late 2026. The project is
      expected to become operational in 2028.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This contract highlights the importance of second-tier and niche suppliers
      in offshore wind delivery. While turbines and foundations dominate
      headlines, system reliability often depends on less visible components
      such as cable protection. As projects scale up and operating lifetimes
      extend, these elements become increasingly critical to asset performance
      and maintenance cost control. 
    </p>
    <p>
      The UK manufacturing element also demonstrates how regional industrial
      capability can capture value within a pan-European project pipeline. From
      a market perspective, this reinforces that offshore wind supply chain
      competitiveness is not only about OEM scale, but also about depth,
      specialisation and engineering expertise.
    </p>
    <h3>5. ASML expands offshore wind PPA with RWE</h3>
    <p>
      ASML has expanded its renewable energy procurement agreement with RWE,
      extending the contract to 2038 and covering approximately 130 MW of
      capacity. The agreement includes electricity from offshore wind assets
      such as Northwester 2 in Belgium, as well as Dutch wind projects including
      OranjeWind. 
    </p>
    <p>
      The power will support ASML’s operations in the Netherlands, reflecting
      growing industrial demand for renewable electricity.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Corporate power demand is becoming a structural driver of offshore wind
      growth. As electrification accelerates across sectors such as
      semiconductors, data infrastructure and advanced manufacturing, long-term
      PPAs provide developers with alternative revenue stability beyond
      government-backed schemes. 
    </p>
    <p>
      For Europe, this trend reinforces the link between energy transition and
      industrial competitiveness. Offshore wind is no longer just a
      decarbonisation tool, but a foundational input into high-value industrial
      ecosystems. The ability to secure long-term corporate demand may
      increasingly differentiate projects in terms of bankability and financing
      conditions.
    </p>
    <h3>
      6. Germany builds world’s tallest wind turbine in former coal mining
      region
    </h3>
    <p>
      Germany has begun constructing what is set to become the world’s tallest
      wind turbine in Lusatia, a region historically reliant on coal and now
      central to the country’s energy transition. The turbine will reach around
      365 metres in height, far exceeding typical onshore wind installations.
    </p>
    <p>
      The project focuses on increasing hub height to capture stronger and more
      stable wind at higher altitudes, rather than relying solely on larger
      rotor diameters. This approach aims to improve energy output in inland
      areas where wind conditions are less optimal, offering a new pathway for
      onshore wind development in constrained markets.
    </p>
    <p>
      It also forms part of a broader strategy to transform former coal regions
      into renewable energy hubs, supporting both decarbonisation and regional
      economic transition.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      This project highlights a shift towards vertical optimisation in mature
      wind markets. Higher hub heights can enhance performance without requiring
      additional land, making them particularly relevant where permitting and
      site availability are limited.
    </p>
    <p>
      At the same time, ultra-tall turbines introduce greater engineering and
      logistical complexity, raising execution requirements across the supply
      chain. Overall, the project reflects a move from scale-driven growth to
      more targeted, efficiency-led deployment.
    </p>
    <h3>7. Japan strengthens floating wind collaboration framework</h3>
    <p>
      Japan’s FLOWRA and Bureau Veritas have signed a memorandum of
      understanding to collaborate on floating offshore wind technologies. The
      agreement focuses on safety, certification and technology development,
      including alignment of international standards. The partnership aims to
      support the reliable and scalable deployment of floating wind,
      particularly within Japan’s emerging offshore wind market.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Floating wind remains a technology with significant long-term potential
      but unresolved commercial challenges. Beyond hardware innovation, one of
      the key barriers to scaling is the lack of mature certification frameworks
      and standardisation. 
    </p>
    <p>
      Partnerships between industry bodies and classification societies play a
      critical role in reducing technical uncertainty and improving investor
      confidence. Japan’s approach reflects a broader trend: successful floating
      wind markets will depend as much on institutional and regulatory
      development as on engineering progress. Establishing trusted standards
      will be essential for unlocking large-scale investment.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
